import React from 'react';
import { RoutingStore } from '../../../stores/RoutingStore';
import { ExperimentsStore } from '../../../../stores/ExperimentsStore';
import { injectStoresV2 } from '../../../stores/injectStoresV2';
import { Template } from '../Template/Template';
import { Template as TemplateType } from '../../../../web-api/domain/template';
import { TemplatesStore } from '../../../stores/TemplatesStore';
import { templatesGridDataHooks } from './TemplatesGrid.dataHooks';
import s from './TemplatesGrid.scss';

interface TemplatesGridProps {
  routingStore: RoutingStore;
  experimentsStore: ExperimentsStore;
  dataHook?: string;
  items: TemplateType[];
  responseUuid: string;
  templatesStore: TemplatesStore;
}

const TemplatesGridCmp = (props: TemplatesGridProps) => {
  const {
    templatesStore: { bestMatchItemIds },
    dataHook,
    items,
  } = props;

  return (
    <ul className={s.templates} data-hook={dataHook}>
      {items.map((template, index) => (
        <Template
          key={template.id}
          dataHook={templatesGridDataHooks.template()}
          template={template}
          galleryDocIndex={index}
          isHiddenOnScreenM={false}
          hasMatchBadge={bestMatchItemIds.includes(template.id)}
        />
      ))}
    </ul>
  );
};

export const TemplatesGrid = injectStoresV2(
  'routingStore',
  'experimentsStore',
  'routingStore',
  'templatesStore',
)(TemplatesGridCmp);
